import { Keypair,Asset as StellarAsset,Networks,
    TransactionBuilder,Operation,Transaction,Memo,MemoType,LiquidityPoolAsset,LiquidityPoolFeeV18, 
    Horizon} from "@stellar/stellar-sdk";
import { Asset, LiquidityPoolDetails } from "../../../../types/types";
import * as stellarApi from '../../horizon/data/data';


const sponsorAccount = `${import.meta.env.VITE_SPONSOR_CHANNEL_ACCOUNT}`;
const isTestnet = import.meta.env.VITE_isTestnet==='true'?true:false;
const slippage = parseFloat(`${import.meta.env.VITE_STELLAR_POOL_LIQUIDITY_SLIPPAGE}`)||0.005;
const networkPhrase = isTestnet?Networks.TESTNET:Networks.PUBLIC;


const horizonUrl = import.meta.env.VITE_HORIZON?import.meta.env.VITE_HORIZON:'https://horizon-testnet.stellar.org'

const api = new Horizon.Server(horizonUrl)

export async function getAssetExchangeQuote(sendAmount:string,sendAssetCode?:string,sendAssetIssuer?:string,destinationAssetCode?:string,destinationAssetIssuer?:string):Promise<[any,Horizon.ServerApi.PaymentPathRecord[]|null]>{

    try { 
        
        let sourceAsset = StellarAsset.native();
        let destinationAsset = StellarAsset.native();
        
        if (sendAssetCode && sendAssetIssuer){
            
            sourceAsset = new StellarAsset(sendAssetCode,sendAssetIssuer);
        }

        if (destinationAssetCode&&destinationAssetIssuer){
            
            destinationAsset = new StellarAsset(destinationAssetCode,destinationAssetIssuer);
        }

        if (sourceAsset == destinationAsset){

            const error = new Error('Origin and destination assets cannot be the same');
            
            return [error,null]

        }

        const es = await api.strictSendPaths(sourceAsset,sendAmount,[destinationAsset]).cursor("now").call();
                
        return [null,es.records]
      
  } catch (error) {

    return [error,null]

      
  }

}

export async function createTradeTx(fromAsset:Asset,fromAssetAmount:string,toAsset:Asset,account_key:string,device_privateKey:string,trading_path:[]):Promise<[any,Transaction<Memo<MemoType>,Operation[]>|null]>{

    let sendAsset = StellarAsset.native();
    let destAsset = StellarAsset.native();

    const device_keyPair = Keypair.fromSecret(device_privateKey);
    const fee = await stellarApi.getNetworkFee();

    const path:StellarAsset[] = []

    if (fromAsset.code!='XLM'){
            
        sendAsset = new StellarAsset(fromAsset.identifier.split(':')[0],fromAsset.identifier.split(':')[1]);
    }

    if (toAsset.code!='XLM'){
        
        destAsset = new StellarAsset(toAsset.identifier.split(':')[0],toAsset.identifier.split(':')[1]);
    }

    trading_path.map((element:any)=>{

        if (element.asset_type==='native'){

            const assetToAdd = StellarAsset.native();
            path.push(assetToAdd) 
        }

        else {

            const assetToAdd = new StellarAsset(element.asset_code,element.asset_issuer);
            path.push(assetToAdd)

        }

    })

    try {

        const sourceAccount = await stellarApi.horizon.loadAccount(account_key);

        let tx: Transaction<Memo<MemoType>, Operation[]>

        if (sendAsset.isNative()){ // in case the user send all its xlm. the account needs to be sponsored

            tx = new TransactionBuilder(sourceAccount, {fee: fee})

                .addOperation(Operation.beginSponsoringFutureReserves({
                    source:sponsorAccount, // account paying for the reserves (sponsor account)
                    sponsoredId: account_key,// account for which the path payment will be sponsored
                }))
                .addOperation(Operation.pathPaymentStrictSend({
                    sendAsset:sendAsset,
                    sendAmount:fromAssetAmount,
                    destination:account_key,
                    destAsset:destAsset,
                    destMin:"0.0000001",
                    path:path
                }))
                .addOperation(Operation.endSponsoringFutureReserves({
                }))
       
            .setNetworkPassphrase(networkPhrase)
            .setTimeout(86400) // transaction valid for a day.
            .build();

            tx.sign(device_keyPair)

            return [null,tx] 

        }

        tx = new TransactionBuilder(sourceAccount, {fee: fee})

            .addOperation(Operation.pathPaymentStrictSend({
                sendAsset:sendAsset,
                sendAmount:fromAssetAmount,
                destination:account_key,
                destAsset:destAsset,
                destMin:"0.0000001",
                path:path
            }))
            .setNetworkPassphrase(networkPhrase)
            .setTimeout(86400) // transaction valid for a day.
            .build();

        tx.sign(device_keyPair)

        return [null,tx] 
        
    } catch (error) {
        
        return [error,null]  
    }
   
}

 export async function createTrustAndTradeTx(fromAsset:Asset,fromAssetAmount:string,toAsset:Asset,account_key:string,device_privateKey:string,trading_path:[]):Promise<[any,Transaction<Memo<MemoType>,Operation[]>|null]>{

    let sendAsset = StellarAsset.native();
    let destAsset = StellarAsset.native();
    const deviceKeyPair = Keypair.fromSecret(device_privateKey);
    const fee = await stellarApi.getNetworkFee();
    const path:StellarAsset[] = []

    if (fromAsset.code!='XLM'){
            
        sendAsset = new StellarAsset(fromAsset.identifier.split(':')[0],fromAsset.identifier.split(':')[1]);
    }

    if (toAsset.code!='XLM'){
        
        destAsset = new StellarAsset(toAsset.identifier.split(':')[0],toAsset.identifier.split(':')[1]);
    }

    trading_path.map((element:any)=>{

        if (element.asset_type==='native'){

            const assetToAdd = StellarAsset.native();
            path.push(assetToAdd) 
        }

        else {

            const assetToAdd = new StellarAsset(element.code,element.issuer);
            path.push(assetToAdd)

        }

    })
 
    try {

        const sourceAccount = await stellarApi.horizon.loadAccount(account_key);

        let tx = new TransactionBuilder(sourceAccount, {fee: fee})

        .addOperation(Operation.beginSponsoringFutureReserves({
            source:sponsorAccount, // account paying for the reserves (sponsor account)
            sponsoredId: account_key,// account for which the trust line will be sponsored
        }))
        .addOperation(Operation.changeTrust({
            asset: destAsset,
        }))
        .addOperation(Operation.endSponsoringFutureReserves({
        }))
        .addOperation(Operation.pathPaymentStrictSend({
            sendAsset:sendAsset,
            sendAmount:fromAssetAmount,
            destination:account_key,
            destAsset:destAsset,
            destMin:"0.0000001",
            path:path
        }))
        
        .setNetworkPassphrase(networkPhrase)
        .setTimeout(86400) // transaction valid for a day.
        .build();

        tx.sign(deviceKeyPair)
           
        return [null,tx]
        
    } catch (error) {

        return [error,null]  
    }

}

export async function createAddPoolLiquidityTx(account_key:string, device_privateKey:string, poolInfo:LiquidityPoolDetails|undefined, maxAmountA:number, maxAmountB:number):Promise<[any,string|any]>{

    const exactPrice = maxAmountA / maxAmountB;
    const minPrice = exactPrice - (exactPrice * slippage);
    const maxPrice = exactPrice + (exactPrice * slippage);
    const fee = await stellarApi.getNetworkFee();
    const deviceKeyPair = Keypair.fromSecret(device_privateKey);

    const sourceAccount = await stellarApi.horizon.loadAccount(account_key);

    let tx = new TransactionBuilder(sourceAccount, {fee: fee})
    
    .addOperation(Operation.liquidityPoolDeposit({
        liquidityPoolId: poolInfo?.id||"",
        maxAmountA: maxAmountA.toString(),
        maxAmountB: maxAmountB.toString(),
        minPrice: minPrice.toFixed(7),
        maxPrice: maxPrice.toFixed(7)
    }))
    .setNetworkPassphrase(networkPhrase)
    .setTimeout(86400) // transaction valid for a day.
    .build();
    tx.sign(deviceKeyPair)
           
    return [null,tx.toEnvelope().toXDR('base64')]
    
}

export async function createTrustAndAddPoolLiquidityTx(account_key:string,device_privateKey:string, poolInfo:LiquidityPoolDetails|undefined, maxAmountA:number, maxAmountB:number){
    
    const poolAssetACode = poolInfo?.assets[0].assetCode;
    const poolAssetAIssuer = poolInfo?.assets[0].asset.split('-')[1];
    const poolAssetBCode = poolInfo?.assets[1].assetCode;
    const poolAssetBIssuer = poolInfo?.assets[1].asset.split('-')[1];


    let asset_A = StellarAsset.native();
    let asset_B = StellarAsset.native();

    if (poolAssetACode&&poolAssetACode!='XLM'){
            
        asset_A = new StellarAsset(poolAssetACode,poolAssetAIssuer);
    }

    if (poolAssetBCode&&poolAssetBCode!='XLM'){
            
        asset_B = new StellarAsset(poolAssetBCode,poolAssetBIssuer);
    }

    const poolAsset = new LiquidityPoolAsset(asset_A, asset_B,LiquidityPoolFeeV18);

    const exactPrice = maxAmountA / maxAmountB;
    const minPrice = exactPrice - (exactPrice * slippage);
    const maxPrice = exactPrice + (exactPrice * slippage);
    const fee = await stellarApi.getNetworkFee();
    const deviceKeyPair = Keypair.fromSecret(device_privateKey);

    const sourceAccount = await stellarApi.horizon.loadAccount(account_key);

    let tx = new TransactionBuilder(sourceAccount, {fee: fee})
    
    .addOperation(Operation.changeTrust({
        asset: poolAsset,
    }))
    .addOperation(Operation.liquidityPoolDeposit({
        liquidityPoolId: poolInfo?.id||"",
        maxAmountA: maxAmountA.toString(),
        maxAmountB: maxAmountB.toString(),
        minPrice: minPrice.toFixed(7),
        maxPrice: maxPrice.toFixed(7)
    }))
    .setNetworkPassphrase(networkPhrase)
    .setTimeout(86400) // transaction valid for a day.
    .build();
    tx.sign(deviceKeyPair)
           
    return [null,tx.toEnvelope().toXDR('base64')]
    
}

export async function removePoolLiquidityTx(account_key:string,device_privateKey:string,poolInfo:LiquidityPoolDetails|undefined, minAmountA:string, minAmountB:string,amount:string):Promise<[any,string|any]>{

    try {

        const fee = await stellarApi.getNetworkFee();
        const deviceKeyPair = Keypair.fromSecret(device_privateKey);

        const sourceAccount = await stellarApi.horizon.loadAccount(account_key);
    
        let tx = new TransactionBuilder(sourceAccount, {fee: fee})

        .addOperation(Operation.liquidityPoolWithdraw({
            liquidityPoolId: poolInfo?.id as string,
            amount:amount,
            minAmountA:minAmountA,
            minAmountB:minAmountB,
            
        }))
        .setNetworkPassphrase(networkPhrase)
        .setTimeout(86400) // transaction valid for a day.
        .build();
        tx.sign(deviceKeyPair)
               
        return [null,tx.toEnvelope().toXDR('base64')]
        
        
    } catch (error) {

        return [error,null]
        
    }
   
}